module.exports = __webpack_public_path__ + "img/feature_2.337c01f3.svg";